var map = {
	"./abis-arbitrum.js": "e57a",
	"./abis-aurora.js": "2250",
	"./abis-avalanche.js": "01e2",
	"./abis-celo.js": "d280",
	"./abis-ethereum.js": "8e2e",
	"./abis-fantom.js": "7f5d",
	"./abis-harmony.js": "df76",
	"./abis-kava.js": "19bd",
	"./abis-moonbeam.js": "6f87",
	"./abis-optimism.js": "872f",
	"./abis-polygon.js": "6afe",
	"./abis-shared.js": "5003",
	"./abis-xdai.js": "f36f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d497";